import { render, staticRenderFns } from "./CanCreateWrapper.vue?vue&type=template&id=f3b52a14&scoped=true&"
import script from "./CanCreateWrapper.vue?vue&type=script&lang=js&"
export * from "./CanCreateWrapper.vue?vue&type=script&lang=js&"
import style0 from "./CanCreateWrapper.vue?vue&type=style&index=0&id=f3b52a14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b52a14",
  null
  
)

export default component.exports